module.exports = __webpack_public_path__ + "static/media/ford_logo.5b56a7bb.png";